import React from 'react';
import { useState } from 'react';
import ResultCont from './ResultCont';
import useMountTransition from './useMountTransition'

const FormCalc = () => {
	
	const [formVisible, setFormVisible] = useState(true);
	const [resultVisible, setResultVisible] = useState(false);
	const [oopsVisible, setOopsVisible] = useState(false);
	const hasTransitionedIn0 = useMountTransition(formVisible, 1000);
	const hasTransitionedIn = useMountTransition(resultVisible, 1000);
	const [cont1, setCont1] = useState();
	const [cont2, setCont2] = useState();
	const [cont3, setCont3] = useState();
	
	const handleSubmit = (event) => {
		event.preventDefault();
		const gpa = document.getElementById('gpa').value;
		const act = document.getElementById('act').value;
		const sat = document.getElementById('sat').value;
		const cali = document.getElementById('cali');
		
		if (gpa =="4.0" || gpa =="3.5" || act =="27" || sat =="1600") {
			setCont1(<h3>Based on what you shared, you may be eligible for the <strong className="red-letter">Saints Scholarship for $14,000</strong>.</h3>);
			setCont3(<div className="tempHide"><h3>You are also eligible to compete for our <strong className="red-letter"><a href="https://www.maryville.edu/admissions/financial-aid/scholarships" target="_blank" rel="noopener noreferrer">Presidential and Trustee Scholarships</a></strong>.</h3></div>);
		}
		
		else if (gpa =="3.0" || act =="26" || sat =="1210") {
			setCont1(<h3>Based on what you shared, you may be eligible for the <strong className="red-letter">Big Red Scholarship for $11,000</strong>.</h3>);
		}
		
		else if (gpa =="2.5" || act =="23" || sat =="1100") {
			setCont1(<h3>Based on what you shared, you may be eligible for the <strong className="red-letter">Opportunity Scholarship for $9,000</strong>.</h3>);
		}
		
		else {
			setCont1(<h3>Please call <strong><a href="tel:+18006279855">1-800-627-9855</a></strong> to talk about your scholarship and grant eligibility with an Admissions Counslor.</h3>);
		}
		
		if(gpa == "" && act == "" && sat == "") {
			setOopsVisible(true);
		} else {
				setFormVisible(false);
				setResultVisible(true);
			}
	}
	if (formVisible || hasTransitionedIn0) {
	return (
		<>
		<div className={`sect ${hasTransitionedIn0 && 'in'} ${formVisible && 'vis'}`}>
			<h2>You've Earned It!</h2>
			<p>Merit-based, need-based – you name it, we've got it. That's because we believe a highly personalized education should be as affordable as it is inspirational. Go ahead and crunch some numbers with our scholarship calculator and see how much of the $50+ million in scholarship money belongs to you.</p>
			<p><strong>Enter what you have.</strong> Admission to Maryville is test-optional, but scholarships can be awarded based on your <strong>GPA, ACT, or SAT</strong> score.</p>
			<form onSubmit={handleSubmit}>
				<div className="inputGroup">
					<label><strong>What's your GPA?</strong></label>
					<div className="selectGroup">
						<select id="gpa">
							<option value="">I'm not sure</option>
							<option value="4.0">3.75 or higher</option>
							<option value="3.5">3.5-3.74</option>
							<option value="3.0">3.0-3.49</option>
							<option value="2.5">2.5-2.99</option>
							<option value="2.0">2.49 or lower</option>
						</select>
					</div>
				</div>
				<div className="inputGroup">
					<label><strong>What's your ACT Score?</strong></label>
					<div className="selectGroup">
						<select id="act">
							<option value="">I'm not sure</option>
							<option value="27">27 or higher</option>
							<option value="26">24-26</option>
							<option value="23">22-23</option>
							<option value="21">21 or Less</option>
						</select>
					</div>
				</div>
				<div className="inputGroup">
					<label><strong>What's your combined SAT Score?</strong></label>
					<div className="selectGroup">
						<select id="sat">
							<option value="">I'm not sure</option>
							<option value="1600">1220 or higher</option>
							<option value="1210">1110-1210</option>
							<option value="1100">1030-1100</option>
							<option value="1020">1020 or Less </option>
						</select>
					</div>
				</div>
				<div className="inputGroup inline">
					{oopsVisible && <p id="oops" className="red-letter"><strong>Oops!</strong> We need at least one of your scores for the calculator.</p>}
				</div>
				<button id="calculate" className="btn btn-success btn-lg" type="submit" aria-label="calculate your scholarship">Calculate</button>
			</form>
		</div>
		</>

		);
	}

	if (resultVisible || hasTransitionedIn) {
		return (
			<div className={`sect ${hasTransitionedIn && 'in'} ${resultVisible && 'vis'}`} >< ResultCont content1={cont1} content2={cont2} content3={cont3} /></div>
			);
	}
}

export default FormCalc;